import { render, staticRenderFns } from "./managementDetailsPurchases.vue?vue&type=template&id=57de9814"
import script from "./managementDetailsPurchases.vue?vue&type=script&lang=js"
export * from "./managementDetailsPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports